export enum EStorageUrls {
  STORAGE = 'storage',
}
